import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import { airPriceWatchOptOutQuery } from './priceWatchQueries'
import { getGraphURL } from '@mfs/client/utils/getServiceUrl'
import { APOLLO_CLIENT_NAME } from '@mfs/client/common/constants/constants'

export const requestPriceWatchOptOut = async ({ watchIds, unsubscribeAll }) => {
  const operationName = 'priceWatchUnsubscribe'
  try {
    const priceWatchOptOutResponse = await axios({
      url: getGraphURL({ operationName }),
      method: 'post',
      headers: {
        'apollographql-client-name': APOLLO_CLIENT_NAME,
        'apollographql-client-version': globalThis.PCLN_BOOTSTRAP_DATA?.appVersion || 'development',
      },
      data: {
        operationName,
        variables: {
          watchIds,
          requestId: uuidv4(),
          unsubscribeAll,
        },
        query: airPriceWatchOptOutQuery,
      },
    })
    return priceWatchOptOutResponse?.data?.data?.priceWatchUnsubscribe
  } catch (err) {
    return {
      status: 'ERROR',
      err: err,
    }
  }
}
